<template>
  <div class="phone-frame">
    <div class="phone-notch" />
    <div class="phone-content">
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  name: 'PhoneFrame'
}
</script>

<style scoped lang="scss">
.phone-frame {
  width: 100%;
  max-width: 360px;
  height: 680px;
  border: 2px solid #1a1a1a;
  border-radius: 24px;
  overflow: hidden;
  background: #fff;
  box-shadow: 0 4px 6px -4px rgba(0, 0, 0, 0.1), 0 10px 15px -3px rgba(0, 0, 0, 0.1);
  position: relative;
  display: flex;
  flex-direction: column;
}

.phone-notch {
  width: 100px;
  height: 24px;
  background: #1a1a1a;
  border-radius: 0 0 14px 14px;
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1;
}

.phone-content {
  padding-top: 32px;
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;

  &::-webkit-scrollbar {
    width: 4px;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 2px;
  }
}
</style>
